import { useState } from "react";
import { publicChapterLabel, publicChapterMembershipHref } from "./publicSiteUtils";

function publicChapterSearchText(chapter = {}) {
  const label = publicChapterLabel(chapter);
  const baseText = [
    chapter.name,
    chapter.city,
    chapter.region,
    chapter.state,
    chapter.postalCode,
    label
  ].filter(Boolean).join(" ");
  const aliases = [];
  if (/\b(saint paul|st\.?\s*paul)\b/i.test(baseText) && /\b(minnesota|mn)\b/i.test(baseText)) {
    aliases.push("Twin Cities", "Minneapolis", "Minneapolis Saint Paul", "Minnesota Twin Cities", "MSP");
  }
  return [
    baseText,
    ...aliases
  ].filter(Boolean).join(" ").toLowerCase();
}

export function OrganizationChapterDirectory({ chapters = [], slug }) {
  const [chapterQuery, setChapterQuery] = useState("");
  if (chapters.length === 0) {
    return null;
  }
  const normalizedQuery = chapterQuery.trim().toLowerCase();
  const visibleChapters = normalizedQuery
    ? chapters.filter((chapter) => publicChapterSearchText(chapter).includes(normalizedQuery))
    : chapters;
  return (
    <section className="public-org-chapter-directory" id="chapters" aria-label="Organization chapters">
      <div className="public-org-chapter-header">
        <div>
          <span className="public-section-kicker">Chapters</span>
          <h3>Choose your local chapter</h3>
          <p>Membership and class rosters stay connected to the chapter you join through.</p>
        </div>
        <a href={`/r/${encodeURIComponent(slug)}/membership`}>View membership</a>
      </div>
      <label className="public-chapter-search">
        <span>Find a chapter</span>
        <input
          type="search"
          value={chapterQuery}
          onChange={(event) => setChapterQuery(event.target.value)}
          placeholder="Search by city or state"
        />
      </label>
      <div className="public-org-chapter-list">
        {visibleChapters.map((chapter) => (
          <article key={chapter.chapterId}>
            <div>
              <strong>{chapter.name}</strong>
              <span>{publicChapterLabel(chapter)}</span>
              {chapter.description && <p>{chapter.description}</p>}
            </div>
            <a href={publicChapterMembershipHref(slug, chapter)}>Join this chapter</a>
          </article>
        ))}
        {visibleChapters.length === 0 && (
          <div className="compact-status-row">No chapters match that search.</div>
        )}
      </div>
    </section>
  );
}
